/* eslint-disable react/forbid-prop-types */

import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { getRoutes } from './routes';
import './styles/app.scss';
import { setCustomerType } from './utils/general';

export const App = ({ customerType }) => {
  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);

  setCustomerType(customerType);

  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* eslint-disable-next-line max-len */}
        <Route
          exact
          path={routes.communicationPreferences.path}
          element={<routes.communicationPreferences.component />}
        />
        <Route path="/error" />
      </Routes>
    </>
  );
};

App.propTypes = {
  customerType: PropTypes.string,
};

App.defaultProps = {
  customerType: 'B2C',
};
